import React from 'react'
import "./ActualResearch.css";

function ActualResearch() {
  return (
    <>
      <div className="research-page-hero" style={{ backgroundImage: "url('/images/sihsbuilding.jpg')" }}>
      <div className="research-overlay">
        <h1>Our Research And Publications</h1>
      </div>
    </div>
    
    </>
  )
}

export default ActualResearch